import React from 'react';
import {
  ButtonSize,
  OptionSelectionButton,
  usePopupManager,
  useShowContextRequired
} from 'ui-builder';
import { useWebhookSubscriptionsService, WebhookSubscription } from 'nekst-api';
import { ConfirmDeletePopup, ConfirmPositiveActionPopup } from 'features/nekst-widgets';
import useSettingsNavigator from '../../../settingsNavigator';
import TestWebhookPopup from './TestWebhookPopup';

export default function WebhookSubscriptionActionsButton() {
  const showContext = useShowContextRequired<WebhookSubscription>();

  const popupManager = usePopupManager();

  const webhookSubscriptionsService = useWebhookSubscriptionsService();

  const settingsNavigator = useSettingsNavigator();

  return (
    <OptionSelectionButton
      options={[
        ...!showContext.data!.isEnabled ? [{
          label: 'Enable Webhook',
          onSelected: () => {
            popupManager.openPopup(
              <ConfirmPositiveActionPopup
                title="Enable Webhook"
                message="Are you sure you want to enable this Webhook?"
                submitFormFunc={async () => {
                  const result = await webhookSubscriptionsService.enableSubscription(
                    showContext.data.id
                  );

                  showContext.updateData(result);
                }}
              />
            );
          },
          value: 'enable',
        }] : [],
        {
          label: 'Test Webhook',
          onSelected: () => {
            popupManager.openPopup(<TestWebhookPopup />);
          },
          value: 'test',
        },
        {
          label: 'Delete Webhook',
          onSelected: () => {
            popupManager.openPopup(
              <ConfirmDeletePopup
                deleteFunc={async () => {
                  await webhookSubscriptionsService.cancelSubscription(showContext.data.id);
                  settingsNavigator.openWebhooksPage();
                }}
                message="Are you sure you want to delete this Webhook?"
              />
            )
          },
          value: 'delete',
        }
      ]}
      text="Actions"
      size={ButtonSize.MEDIUM}
    />
  );
}
